import React, { useState } from "react";
import WithCamera from "../../components/WithCamera";
import InvitationView from "./components/InvitationView";
import { useGetInfoTeam } from "./hooks/useGetInfoTeam";
import { useScrollPage } from "../ChampionsThrophyScreen/hooks/useScrollPage";
import WelcomeView from "./components/WelcomeView";
import { motion, AnimatePresence } from 'framer-motion';



const ChallengeIntroduceTeamScreen = ()=>{
    const [pageView, setPageView] = useState("introduce")
   const { teamInfo } = useGetInfoTeam();
   const heightFromHeader = document.getElementsByClassName('talacha-header')?.[0]?.offsetHeight;
   useScrollPage(heightFromHeader)
   const setViewPage = view => setPageView(view)
   const introduceViewMap = {
    "introduce": <InvitationView teamInfo={teamInfo} selectView={setViewPage} />,
    "welcome": <WelcomeView teamInfo={teamInfo} />
   }

const fadeTransition = {
  // 1. Vista de Entrada: Transparente
  initial: { 
    opacity: 0, 
  },
  // 2. Vista Activa: Posición final
  animate: { 
    opacity: 1, 
    transition: { 
      duration: 0.4, 
      delay: 0.2 // Pequeño delay para que la salida comience primero
    } 
  },
  // 3. Vista de Salida: Se vuelve transparente
  exit: { 
    opacity: 0,
    transition: { 
      duration: 0.4
    } 
  }
};


    return(
        <WithCamera>
            <AnimatePresence mode="wait">
                <motion.div
                    key={pageView} // <- ESTO ES CLAVE: Cambia cuando pageView cambia
                    variants={fadeTransition}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    // Estilo para asegurar que las vistas se superpongan durante la transición
                >
                    {introduceViewMap[pageView]}
                </motion.div>
            </AnimatePresence>        
        </WithCamera>
    )
}

export default ChallengeIntroduceTeamScreen